<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Demir"
    }
</script>

<style scoped>

</style>